import { createSelector } from 'reselect';
import { initialState } from './users.reducers';

const selectUsers = (state: any) => state.usersReducer || initialState;

const makeSelectUsers = () =>
  createSelector(
    selectUsers,
    usersState => usersState.users,
  );
const makeSelectContacts = () =>
  createSelector(
    selectUsers,
    usersState => usersState.contacts,
  );

export { selectUsers, makeSelectUsers, makeSelectContacts };
